import api from "./api";
import {mapEmployeeProfileDto} from "../dto/EmployeeProfileDto";

export const createEmployeeProfileForUser = async (userId, dto) => {
    try {
        const res = await api.post(`/EmployeeProfile/${userId}`, dto);
        return res.data;
    } catch (err) {
        console.error("Error creating EmployeeProfile:", err);
        throw err;
    }
};

export const updateEmployeeProfileForUser = async (userId, dto) => {
    try {
        const res = await api.put(`/EmployeeProfile/${userId}`, dto);
        return res.data;
    } catch (err) {
        console.error("Error updating EmployeeProfile:", err);
        throw err;
    }
};

export const deleteEmployeeProfileForUser = async (userId) => {
    try {
        const res = await api.delete(`/EmployeeProfile/${userId}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting EmployeeProfile:", err);
        throw err;
    }
};

export const getEmployeeProfileForUser = async (userId) => {
    try {
        const res = await api.get(`/EmployeeProfile/${userId}`);

        return mapEmployeeProfileDto(res.data);
    } catch (err) {
        console.error("Error getting employee profile for user:", err);
        throw err;
    }
};

// Streamed through the API, not a presigned URL: an `<img src>` cannot send the `X-API-Key`
// header, so the editor renders the bytes from an object URL (revoke it).
export const uploadProfilePhoto = async (userId, file) => {
    const body = new FormData();
    body.append("file", file);
    const res = await api.post(`/EmployeeProfile/${userId}/photo`, body);
    return res.data;
};

export const getProfilePhotoBlob = async (userId) => {
    const res = await api.get(`/EmployeeProfile/${userId}/photo`, {responseType: "blob"});
    return res.data;
};

export const deleteProfilePhoto = async (userId) => {
    const res = await api.delete(`/EmployeeProfile/${userId}/photo`);
    return res.data;
};
